export default "__VITE_ASSET__733b0d6a__"